<script>
import { mapGetters } from 'vuex';
import { MESSAGE_VARIABLES } from 'shared/constants/messages';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  inject: {
    // Ligado pelo `provide` do editor de fluxos: lá a lista mora dentro do
    // painel de configuração, que é um contêiner de scroll, e o
    // `absolute bottom-full` do MentionBox era recortado na borda. Fora dali
    // (caixa de resposta, TemplateParser) não há provider, e o default false
    // mantém o posicionamento atual.
    mentionBoxFloating: { default: false },
  },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
    allowedPrefixes: {
      type: Array,
      default: () => [],
    },
    // Variáveis adicionais ({ label, key, description }) mostradas ANTES das
    // do sistema (ex.: variáveis do fluxo). Não passam pelo filtro de
    // prefixos — quem as injeta já decidiu que valem neste contexto.
    extraVariables: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      customAttributes: 'attributes/getAttributes',
    }),
    items() {
      const variables = [
        ...this.standardAttributeVariables,
        ...this.customAttributeVariables,
      ];

      const filtered = !this.allowedPrefixes.length
        ? variables
        : variables.filter(variable =>
            this.allowedPrefixes.some(prefix => variable.key.startsWith(prefix))
          );

      return [...this.extraVariableItems, ...filtered];
    },
    // Busca case-insensitive — igual ao AutomationVariableTextInput, para a
    // MESMA variável não filtrar diferente conforme o campo.
    normalizedSearchKey() {
      return (this.searchKey || '').toLowerCase();
    },
    extraVariableItems() {
      return this.extraVariables.filter(variable => {
        const label = (variable.label || variable.key || '').toLowerCase();
        const key = (variable.key || '').toLowerCase();
        return (
          label.includes(this.normalizedSearchKey) ||
          key.includes(this.normalizedSearchKey)
        );
      });
    },
    standardAttributeVariables() {
      return MESSAGE_VARIABLES.filter(variable => {
        return (
          variable.label.toLowerCase().includes(this.normalizedSearchKey) ||
          variable.key.toLowerCase().includes(this.normalizedSearchKey)
        );
      }).map(variable => ({
        label: variable.key,
        key: variable.key,
        description: this.$t(variable.label),
      }));
    },
    customAttributeVariables() {
      return this.customAttributes.map(attribute => {
        const attributePrefix =
          attribute.attribute_model === 'conversation_attribute'
            ? 'conversation'
            : 'contact';

        return {
          label: `${attributePrefix}.custom_attribute.${attribute.attribute_key}`,
          key: `${attributePrefix}.custom_attribute.${attribute.attribute_key}`,
          description: attribute.attribute_description,
        };
      });
    },
  },
  methods: {
    handleVariableClick(item = {}) {
      this.$emit('click', item.key);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    type="variable"
    :items="items"
    :floating="mentionBoxFloating"
    @mentionSelect="handleVariableClick"
  />
</template>

<style scoped>
.variable--list-label {
  font-weight: var(--font-weight-bold);
}
</style>
